import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfIframeObjectCtrl - Controller for handling iframe objects.
 * Extends BaseObjectDirective to manage iframe-specific functionalities.
 */
export class AsfIframeObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfIframeObjectCtrl.
     * Initializes the controller with necessary services and scope variables.
     * @param {Object} $element - Angular element service.
     * @param {Object} $injector - Angular injector service.
     * @param {Object} $scope - Angular scope service.
     * @param {Object} $rootScope - Angular root scope service.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $sce - Angular SCE service for secure context escaping.
     * @param {Object} TaskSelectionService - Service for task selection.
     * @param {Object} $q - Angular promise service.
     * @param {Object} SheetLoadedService - Service to check if sheet is loaded.
     * @param {Object} $timeout - Angular timeout service.
     * @param {Object} $interval - Angular interval service.
     */
    constructor($element, $injector, $scope, $rootScope, $signals, $uibModal, $sce, TaskSelectionService, $q, SheetLoadedService, $timeout, $interval) {
        super($injector, $scope);

        this.registerObjectInstance('iframe');
        this.contentObject = $scope.contentObject;

        $scope.isCMS = $rootScope.isCMS && !$rootScope.isPreview;
        $scope.prefsMode = false;
        $scope.hasBrowseImage = true;
        $scope.hasUploadImage = false;
        $scope.selectable = true;

        // Determine which Task we're in
        $scope.taskuuid = TaskSelectionService.getTaskUUID();

        var isoConfig = {
            root: null,
            rootMargin: '0px',
            threshold: 0.6
        };

        var originalAdobeFPS = null;
        var lastIsoIsIntersecting = null;

        /**
         * Resets the FPS of the Adobe iframe content to the original value.
         * @param {HTMLElement} iframeEl - The iframe element.
         */
        var adobeIframeContentSetOldFPS = function(iframeEl) {
            if (originalAdobeFPS != null) {
                console.log("[IFRAME] Resetting createjs FPS to "+originalAdobeFPS);
                iframeEl.contentWindow.createjs.Ticker._setFPS(originalAdobeFPS);
                originalAdobeFPS = null;
            }
        };

        /**
         * Reduces the FPS of the Adobe iframe content.
         * @param {HTMLElement} iframeEl - The iframe element.
         */
        var adobeIframeContentReduceFPS = function(iframeEl) {
            console.log("[IFRAME] Reducing createjs FPS",iframeEl);
            var fpsTmp = iframeEl.contentWindow.createjs.Ticker._getFPS();
            if (fpsTmp >= 6) {
                originalAdobeFPS = fpsTmp;
            }
            iframeEl.contentWindow.createjs.Ticker._setFPS(0.33);
        }

        /**
         * Debounced function to reduce FPS if the last state was non-intersecting.
         * @param {HTMLElement} iframeEl - The iframe element.
         */
        var afterCanvasClickRestoreDebounce = _.debounce(function(iframeEl) {
            console.log("[IFRAME] Running adobeIframeContentReduceFPSIfLastStateNonIntersecting after click");
            adobeIframeContentReduceFPSIfLastStateNonIntersecting(iframeEl);
        },3000);

        /**
         * Delayed function to reduce FPS if the last state was non-intersecting.
         * @param {HTMLElement} iframeEl - The iframe element.
         */
        var adobeIframeContentReduceFPSIfLastStateNonIntersectingDelayed = function(iframeEl) {
            console.log("[IFRAME] adobeIframeContentReduceFPSIfLastStateNonIntersectingDelayed",iframeEl);
            $timeout(function() {
                adobeIframeContentReduceFPSIfLastStateNonIntersecting(iframeEl);

                $(iframeEl.contentDocument).find("canvas").on("click",function() {
                    console.log("[IFRAME] Canavas clicked -> Temporarily restoring framerate");
                    adobeIframeContentSetOldFPS(iframeEl);

                    afterCanvasClickRestoreDebounce(iframeEl);

                })

            }, 5000, false);

            var lInt = $interval(function() {
                if (iframeEl.contentWindow === null) {
                    return;
                }
                if (!iframeEl.contentWindow.hasOwnProperty("createjs")) {
                    return;
                }
                var fps = iframeEl.contentWindow.createjs.Ticker._getFPS();
                var mfps = iframeEl.contentWindow.createjs.Ticker.getMeasuredFPS();
                var interval = iframeEl.contentWindow.createjs.Ticker._getInterval();
                var mtick = iframeEl.contentWindow.createjs.Ticker.getMeasuredTickTime();
                console.log("[IFRAME] FPS: "+fps+" MFPS: "+mfps+" INTERVAL: "+interval+" MTICK: "+mtick+" lastIsoIsIntersecting: "+lastIsoIsIntersecting);
            },3000,0,false);

            $scope.$on('$destroy', function () {
                console.log("destroy3-interval");
                $interval.cancel(lInt);
            });

        }

        /**
         * Checks if an element is scrolled into view.
         * @param {HTMLElement} elem - The element to check.
         * @returns {boolean} - True if the element is in view, false otherwise.
         */
        var isScrolledIntoView = function(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        /**
         * Reduces FPS if the last state was non-intersecting.
         * @param {HTMLElement} iframeEl - The iframe element.
         */
        var adobeIframeContentReduceFPSIfLastStateNonIntersecting = function(iframeEl) {
            console.log("[IFRAME] adobeIframeContentReduceFPSIfLastStateNonIntersecting"+lastIsoIsIntersecting,iframeEl.contentWindow);

            if (iframeEl.contentWindow === null) {
                console.log("[IFRAME] Iframe contentWindow still null, ignoring!");
                return;
            }
            if (!iframeEl.contentWindow.hasOwnProperty("createjs")) {
                console.log("[IFRAME] Iframe with non-adobe content, ignoring!");
                return;
            }

            var isIntersecting = lastIsoIsIntersecting;
            if (isIntersecting === null) {
                isIntersecting = isScrolledIntoView(iframeEl);
                lastIsoIsIntersecting = true;
                console.log("[IFRAME] adobeIframeContentReduceFPSIfLastStateNonIntersecting last ISO state unknown, checking using jquery "+isIntersecting);
            }

            if (!isIntersecting) {
                console.log("[IFRAME] Iframe loaded, but off screen", iframeEl);
                adobeIframeContentReduceFPS(iframeEl);
            } else {
                console.log("[IFRAME] Iframe loaded, on screen");
            }
        }

        /**
         * Handles changes in intersection observer.
         * @param {Array} changes - Array of change records.
         * @param {IntersectionObserver} observer - The intersection observer.
         */
        var onIsoChange = function (changes, observer) {
            _.each(changes, function(change) {
                var iframeEl = $element.find("iframe")[0];
                console.log("[IFRAME] ISO CHANGE "+change.isIntersecting+"-"+change.intersectionRatio,change);
                lastIsoIsIntersecting = change.isIntersecting;

                if (!iframeEl.contentWindow) {
                    return;
                }
                if (!iframeEl.contentWindow.hasOwnProperty("createjs")) {
                    return;
                }

                var isIntersecting = change.isIntersecting;
                if (typeof(isIntersecting) === 'undefined') {
                    console.log("[IFRAME] ISO CHANGE isIntersecting undefined, checking ratio"+change.intersectionRatio);
                    isIntersecting = change.intersectionRatio >= isoConfig.threshold;
                    lastIsoIsIntersecting = isIntersecting;
                }
                console.log("[IFRAME] ISO CHANGE -> Seems that we have Adobe content "+isIntersecting,change.isIntersecting, change.intersectionRatio,change, iframeEl.contentWindow);

                if (isIntersecting) {
                    adobeIframeContentSetOldFPS(iframeEl);
                } else {
                    adobeIframeContentReduceFPS(iframeEl);
                }

            });
        };

        var isoObserver = new IntersectionObserver(onIsoChange, isoConfig);
        isoObserver.observe($element[0]);
        $scope.$on('$destroy', function () {
            console.log("destroy2-iso");
            isoObserver.disconnect();
        });

        $scope.mediaObject = $scope.contentObject.getContentReference(false) || false;
        $scope.hasPreviewURL = false;

        /**
         * Gets the iframe URL based on the media object and thumbnail.
         * @param {Object} mediaObject - The media object.
         * @param {boolean} thumbnail - Whether to get the thumbnail URL.
         * @returns {string|boolean} - The iframe URL or false if not available.
         */
        var getIframeURL = function (mediaObject, thumbnail) {
            var iframePreviewURL = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().iframePreviewURL : false);

            if ($rootScope.isPreview && iframePreviewURL !== false && angular.isString(iframePreviewURL) && iframePreviewURL.startsWith("http")) {
                $sce.trustAsResourceUrl(iframePreviewURL);
                $signals.emit(IB.Signals.ADD_SCE_WHITELIST, iframePreviewURL + '**');
                $signals.emit(IB.Signals.ADD_SCE_WHITELIST, iframePreviewURL + '/**');

                return iframePreviewURL;
            }

            var thumbnailSlug = '_thumb',
                thumbnailExtension = 'jpg';

            if (!angular.isObject(mediaObject)) {
                return false;
            }

            var re = /(?:\.([^.]+))?$/,
                uploadName = mediaObject.getUploadName(),
                extension = thumbnail ? thumbnailExtension : re.exec(uploadName)[1],
                mimeType = mediaObject.getMimeType(),
                fileNameSlug = thumbnail ? thumbnailSlug : "",
                fileName = mediaObject.getUUID() + fileNameSlug + '.' + extension,
                url = false;

            if (mimeType == 'image/svg+xml') {
                filename = mediaObject.getUUID() + fileNameSlug + '.svg'
                url = isCMS ? "/media/" + $scope.taskuuid + "/" + fileName : "/media/" + fileName;
            } else if (mimeType == 'application/zip') {
                url = isCMS ?
                    "/iframe/" + $scope.taskuuid + "/" + mediaObject.getUUID() + "/index.html"
                    :
                    "/media/iframe-content/" + mediaObject.getUUID() + "/index.html";
            }

            return url + '?uuid=' + $scope.contentObject.getUUID();
        };

        /**
         * Refreshes the iframe URL.
         */
        var refreshIframeURL = function () {
            // 'about:blank' is used as a no-op placeholder when the iframe should not yet load
            // its content. Previously this was '.', which the browser resolves to '/', causing
            // the service worker to serve the full SPA index.html into the iframe, which then
            // auto-resumed the exam and spawned phantom Angular instances (one per inactive tab).
            // Wrap with $sce.trustAsResourceUrl because $sceDelegate's default policy blocks
            // about:blank for ng-src on iframes.
            $scope.iframeURL = ($scope.$parent.loadObjectUrl  || $scope.isPDFMode || $scope.examExport) ? getIframeURL($scope.mediaObject) : $sce.trustAsResourceUrl('about:blank');
            // $sce.trustAsResourceUrl returns a wrapper that stringifies to [object Object];
            // unwrap with $sce.valueOf so the log shows the actual URL.
            console.log("Using iFrame URL: "+$sce.valueOf($scope.iframeURL)+" - "+$scope.examExport);

            if (typeof $scope.contentObject.getPreferences() != "undefined") {
                var preferences = $scope.contentObject.getPreferences();
                var iframePreviewURLtmp = (typeof preferences.iframePreviewURL !== "undefined" ? preferences.iframePreviewURL : "");
                $scope.hasPreviewURL = angular.isString(iframePreviewURLtmp) && iframePreviewURLtmp.startsWith("http");
            }

        };
        refreshIframeURL();

        var _tmp = $scope.resetChanges;
        $scope.resetChanges = function () {
            _tmp();
            console.log("override # <" + this.injections.$scope.contentObject.getUUID() + "> resetChanges()");
            this.injections.$scope.initPreferences();
            refreshIframeURL();
        }.bind(this);

        /**
         * Gets the display height from preferences.
         * @returns {number} - The display height.
         */
        var getDisplayHeight = function () {
            return (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().displayHeight : 500);
        };

        /**
         * Generates styles based on preferences.
         */
        var generateStyles = function () {
            $scope.styles = {height: getDisplayHeight() + 'px'};
        };
        generateStyles();

        var isCMSNotPreview = $rootScope.isCMS && !$rootScope.isPreview;

        /**
         * Initializes preferences and sets up watchers.
         */
        $scope.initPreferences = function () {
            var displayHeight = getDisplayHeight();
            var includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : false);
            var iframePreviewURL = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().iframePreviewURL : "");
            var interactInReadingTime = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().interactInReadingTime : false);

            if (isCMSNotPreview) {
                $scope.$watch('preferencesValues', function (val1, val2) {
                    if (val1 == val2)
                        return;
                    var preferences = {};
                    angular.forEach($scope.preferencesValues, function (value, key) {
                        preferences[key] = value;
                    });

                    $scope.contentObject.setPreferences(preferences);

                    generateStyles();
                    refreshIframeURL();
                }, true);
            }

            $scope.preferencesValues = {};
            $scope.preferencesValues['displayHeight'] = displayHeight;
            $scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : false;
            $scope.preferencesValues['iframePreviewURL'] = iframePreviewURL;
            $scope.preferencesValues['interactInReadingTime'] = typeof interactInReadingTime !== 'undefined' ? interactInReadingTime : false;

            $scope.preferences = [
                {
                    'alttext': [
                        {'type': 'input', 'name': 'Height (px)', 'valueKey': 'displayHeight'}
                    ],
                    'includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ],
                    'interactInReadingTime': [
                        {'type': 'checkbox', 'name': 'Unlock in Reading-Time', 'valueKey': 'interactInReadingTime'}
                    ],
                    'iframePreviewURL': [
                        {
                            'type': 'input',
                            'name': 'Preview URL (for debugging, use with care)',
                            'valueKey': 'iframePreviewURL'
                        }
                    ]
                },
            ];
        };

        $scope.initPreferences();

        var modalInstance = null;
        $scope.onMediaBrowseButtonClick = function () {
            modalInstance = $uibModal.open({
                templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediabrowserModal.html',
                scope: $scope,
                controller: browseModalInstanceController,
                resolve: {
                    'contentObjectUUID': function () {
                        return $scope.contentObject.getUUID();
                    }
                }
            });
        }

        var browseModalInstanceController = function ($scope, $uibModalInstance, contentObjectUUID) {
            $scope.showonly = 'iframe';
            $scope.contentobjectuuid = contentObjectUUID;

            $scope.onModalCloseButtonClick = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }

        var onSelectMedia = function (selectedMedia) {
            if (selectedMedia.contentobjectuuid == $scope.contentObject.getUUID()) {
                $scope.contentObject.setContentReference(selectedMedia.uuid);
                var mediaObject = $scope.contentObject.getContentReference();
                console.log(selectedMedia, mediaObject);

                $scope.mediaObject = mediaObject;
                $scope.iframeURL = getIframeURL(mediaObject);
                console.log('OB ==>', $scope.iframeURL);

                if (modalInstance !== null) {
                    modalInstance.close();
                }
            }
        };

        $scope.$on('$destroy', function () {
            console.log("destroy1");
            $signals.remove(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, onSelectMedia);
        });

        $signals.on(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, onSelectMedia);

        var _d = $q.defer();
        SheetLoadedService.wait(_d.promise, 'iframe');

        // When the iframe is a no-op placeholder (about:blank, set when the
        // parent's loadObjectUrl is false for inactive tabs), there's no real
        // content to wait for. Resolve immediately — about:blank's load event
        // can fire before the $timeout below attaches the .load() listener,
        // and that race would otherwise block the sheet-loaded promise until
        // the 7s fallback even though nothing is loading.
        var isPlaceholder = !$scope.$parent.loadObjectUrl && !$scope.isPDFMode && !$scope.examExport;
        if (isPlaceholder) {
            _d.resolve('iframe');
        } else {
            $timeout(function () {
                if ($scope.$parent.element.find('iframe').length > 0) {
                    $scope.$parent.element.find('iframe').load(function () {
                        _d.resolve('iframe');

                        var iframeEl = $element.find("iframe")[0];
                        $(iframeEl.contentDocument).ready(function() {
                            adobeIframeContentReduceFPSIfLastStateNonIntersectingDelayed(iframeEl);
                        });
                    });
                } else {
                    _d.resolve('iframe');
                }
            });
        }
    }
}

export default function registerIframeObjectDirective(module) {
    module.directive('asfIframeObject', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "examExport": '=?',
                "contentObject": "="
            },
            templateUrl: isCMS ? "/views/ib/contentobjects/iframeCMS.html" : "/views/ib/contentobjects/iframe.html",
            controller: AsfIframeObjectCtrl
        };
    });

    module.directive('iframeMojaveCheckboxRadioboxFix', ['$injector', '$', '$timeout', function ($injector, $, $timeout) {
        return {
            link: function (scope, element, attrs) {
                var fixInputElement = function (idx, input) {
                    var tagName = $(input).prop("tagName").toLowerCase(),
                        inputType = $(input).attr("type"),
                        inputType = !angular.isDefined(inputType) && (tagName == 'input') ? 'text' : inputType.toLowerCase(); /*CONTINUED*/

                    if (inputType === 'radio' || inputType === 'checkbox') {
                        $(input).css('zoom', '1.0000001');
                    }
                };

                var fixAllInputElements = function () {
                    var iframeDocument = element[0].contentDocument || element[0].contentWindow.document;
                    var inputs = $(iframeDocument).find("INPUT");
                    $(inputs).each(fixInputElement);
                };

                var onLoad = function () {
                    console.log("Installing mojave checkbox/radio fix for iframe", element);
                    $timeout(fixAllInputElements, 200);
                };

                element.on('load', onLoad);
            } // function()
        } // return
    }]);
}